import PageHero from "../components/PageHero";
import CtaBanner from "../components/CtaBanner";
import { Reveal, SectionHeading } from "../components/Reveal";
import { INTERIOR_IMAGES } from "../data/site";
import { Ruler, FileCheck2, Clock, HardHat } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";

const VALUE_ICONS = [Ruler, FileCheck2, Clock, HardHat];

export default function ChiSiamo() {
  const { t } = useLang();

  return (
    <div data-testid="chi-siamo-page">
      <PageHero
        overline={t.chiSiamo.overline}
        title={t.chiSiamo.title}
        desc={t.chiSiamo.desc}
        images={[INTERIOR_IMAGES.kitchen, INTERIOR_IMAGES.bathroom]}
        imageAlt={t.chiSiamo.imageAlt}
      />

      <section className="relative overflow-hidden bg-white py-20 sm:py-24" data-testid="values-section">
        <img
          src={INTERIOR_IMAGES.living}
          alt=""
          aria-hidden="true"
          className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-[0.06]"
        />
        <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
          <SectionHeading
            overline={t.chiSiamo.valuesOverline}
            title={t.chiSiamo.valuesTitle}
            desc={t.chiSiamo.valuesDesc}
          />
          <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {t.chiSiamo.values.map((v, i) => {
              const Icon = VALUE_ICONS[i];
              return (
                <Reveal key={v.title} delay={i * 0.08}>
                  <div
                    className="flex h-full flex-col rounded-2xl border border-line bg-white p-7 shadow-sm transition-[transform,box-shadow] duration-300 hover:-translate-y-1.5 hover:shadow-xl hover:shadow-slate-900/5"
                    data-testid={`value-card-${i}`}
                  >
                    <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand/10 text-brand">
                      <Icon size={22} />
                    </span>
                    <h3 className="mt-6 font-heading text-lg font-semibold text-slate-900">{v.title}</h3>
                    <p className="mt-3 text-sm leading-relaxed text-slate-500">{v.desc}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>

      <CtaBanner />
    </div>
  );
}
